export const EngineerSessionLocationVerificationMethod = {
  ACCESS_CODE: 'ACCESS_CODE',
  GEOLOCATION: 'GEOLOCATION',
  GEOLOCATION_AND_ACCESS_CODE: 'GEOLOCATION_AND_ACCESS_CODE',
}
